import { type FC, type PropsWithChildren } from 'react'

import { z } from 'zod'

import { ZodFormSubmitProvider } from '@/components/atoms/Form/ZodFormSubmitProvider'
import { cn } from '@/lib/utils'

export interface TeamMessageFormProviderProps {
  onSendMessage: (message: string) => Promise<void> | void
  className?: string
}

const TeamMessageFormZod = z.object({
  message: z.string().optional().default(''),
})

export type TeamMessageFormData = z.infer<typeof TeamMessageFormZod>

export const TeamMessageFormProvider: FC<PropsWithChildren<TeamMessageFormProviderProps>> = ({
  className,
  onSendMessage,
  children,
}) => (
  <ZodFormSubmitProvider
    schema={TeamMessageFormZod}
    defaultValues={{ message: '' }}
    resetOnSubmit
    className={cn('flex flex-col text-base', className)}
    onFormSubmit={({ message }) => onSendMessage(message)}>
    {children}
  </ZodFormSubmitProvider>
)
